<script>
export default {
  name: 'CheckoutInfo',
  props: {
    checkoutData: {
      type: Object,
      required: true
    },
    srcCorrelationId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      checkoutResponse: {},
      maskedConsumer: {},
      maskedCard: {},
      maskedBillingAddress: {}
    }
  },
  created () {
    this.checkoutResponse = (this.checkoutData || {}).checkoutResponse || {}
    this.maskedConsumer = this.checkoutResponse.maskedConsumer || {}
    this.maskedCard = this.checkoutResponse.maskedCard || {}
    this.maskedBillingAddress = this.maskedCard.maskedBillingAddress || {}
  }
}
</script>

<template>
  <div id="checkout-info">
    <p>
      <span class="font-weight-bold">{{ $t ('label.cardType') }} :</span>
      <span>{{ checkoutData.srcNetwork }}</span>
    </p>
    <p>
      <span class="font-weight-bold">{{ $t ('label.srcCorrelationId') }} : </span>
      <span>{{ srcCorrelationId }} </span>
    </p>

    <div class="card mb-2">
      <h5
        aria-expanded="false"
        class="card-header collapsed cursor-pointer"
        data-target="#consumerDetails"
        data-toggle="collapse"
      >
        {{ $t ('label.consumerDetails') }}
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="consumerDetails"
        class="card-body collapse"
      >
        <p>
          <span>{{ $t ('label.srcConsumerId') }} : </span>
          <span>{{ maskedConsumer.srcConsumerId }}</span>
        </p>
        <p>
          <span>{{ $t ('label.emailId') }} : </span>
          <span>{{ maskedConsumer.maskedEmailAddress }}</span>
        </p>
        <p>
          <span>{{ $t ('label.firstName') }} : </span>
          <span>{{ maskedConsumer.maskedFirstName }}</span>
        </p>
        <p>
          <span>{{ $t ('label.lastName') }} : </span>
          <span>{{ maskedConsumer.maskedLastName }}</span>
        </p>
        <p>
          <span>{{ $t ('label.fullName') }} : </span>
          <span>{{ maskedConsumer.maskedFullName }}</span>
        </p>
        <p>
          <span>{{ $t ('label.mobileNum') }} : </span>
          <span>{{ maskedConsumer.maskedMobileNumber }}</span>
        </p>
        <p>
          <span>{{ $t ('label.status') }} :</span>
          <span>{{ maskedConsumer.status }}</span>
        </p>
        <p>
          <span>{{ $t ('label.countryCode') }} :</span>
          <span>{{ maskedConsumer.countryCode }}</span>
        </p>
        <p>
          <span>{{ $t ('label.languageCode') }} : </span>
          <span>{{ maskedConsumer.languageCode }}</span>
        </p>
        <p>
          <span>{{ $t ('label.dateConsumerAdded') }} :</span>
          <span>{{ maskedConsumer.dateConsumerAdded }}</span>
        </p>
        <p>
          <span> {{ $t ('label.dateConsumerLastUsed') }} : </span>
          <span>{{ maskedConsumer.dateConsumerLastUsed }}</span>
        </p>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="cardDetails"
        aria-expanded="false"
        class="card-header collapsed cursor-pointer"
        data-target="#cardDetails"
        data-toggle="collapse"
      >
        <span>{{ $t ('label.cardDetails') }}</span>
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>

      <div
        id="cardDetails"
        class="card-body collapse"
      >
        <p>
          <span> {{ $t ('label.srcDigitalCardId') }} : </span>
          <span>{{ maskedCard.srcDigitalCardId }}</span>
        </p>
        <p>
          <span> {{ $t ('label.panBin') }} : </span>
          <span>{{ maskedCard.panBin }}</span>
        </p>
        <p>
          <span> {{ $t ('label.panExpirationMonth') }} : </span>
          <span>{{ maskedCard.panExpirationMonth }}</span>
        </p>
        <p>
          <span> {{ $t ('label.panExpirationYear') }} : </span>
          <span>{{ maskedCard.panExpirationYear }}</span>
        </p>
        <p>
          <span> {{ $t ('label.panLastFour') }} :</span>
          <span> {{ maskedCard.panLastFour }}</span>
        </p>
        <p>
          <span> {{ $t ('label.tokenLastFour') }} : </span>
          <span> {{ maskedCard.tokenLastFour }}</span>
        </p>
        <p>
          <span> {{ $t ('label.dateOfCardCreated') }} : </span>
          <span> {{ maskedCard.dateOfCardCreated }}</span>
        </p>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="paymentToken"
        aria-expanded="false"
        class="card-header collapsed cursor-pointer"
        data-target="#paymentToken"
        data-toggle="collapse"
      >
        {{ $t ('label.paymentToken') }}
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="paymentToken"
        class="card-body collapse"
      >
        <p>
          <span>{{ $t ('label.idToken') }} : </span>
          <span class="wrap-text">{{ checkoutData.idToken || checkoutData.checkoutResponseSignature || checkoutResponse }}</span>
        </p>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="shippingDetails"
        aria-expanded="false"
        class="card-header collapsed cursor-pointer"
        data-target="#shippingDetails"
        data-toggle="collapse"
      >
        {{ $t ('label.shippingDetails') }}
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="shippingDetails"
        class="card-body collapse"
      >
        <p>
          <span> {{ $t ('label.shippingAddressZip') }} : </span>
          <span>{{ checkoutResponse.shippingAddressZip }} </span>
        </p>
        <p>
          <span> {{ $t ('label.shippingCountryCode') }} : </span>
          <span> {{ checkoutResponse.shippingCountryCode }}</span>
        </p>
      </div>
    </div>

    <div class="card mb-2">
      <h5
        aria-controls="billingAddressDetails"
        aria-expanded="false"
        class="card-header collapsed cursor-pointer"
        data-target="#billingAddressDetails"
        data-toggle="collapse"
      >
        {{ $t ('label.billingAddressDetails') }}
        <span class="collapsible-arrow pull-right cursor-pointer" />
      </h5>
      <div
        id="billingAddressDetails"
        class="card-body collapse"
      >
        <p>
          <span> {{ $t ('label.addressId') }} : </span>
          <span>{{ maskedBillingAddress.addressId }}</span>
        </p>
        <p>
          <span> {{ $t ('label.city') }} : </span>
          <span> {{ maskedBillingAddress.city }}</span>
        </p>
        <p>
          <span> {{ $t ('label.countryCode') }} : </span>
          <span> {{ maskedBillingAddress.countryCode }}</span>
        </p>
        <p>
          <span> {{ $t ('label.line1') }} : </span>
          <span>{{ maskedBillingAddress.line1 }}</span>
        </p>
        <p>
          <span> {{ $t ('label.state') }} : </span>
          <span>{{ maskedBillingAddress.state }}</span>
        </p>
        <p>
          <span> {{ $t ('label.zip') }} : </span>
          <span> {{ maskedBillingAddress.zip }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
